import React from 'react'
import WrapperAccordion from '../general/WrapperAccordion';
import PagesListContainer from '../../containers/PageWebsiteSubpages/PagesListContainer';
import WebsiteMenuContainer from '../../containers/PageWebsiteSubpages/WebsiteMenuContainer';

const PagesSection = ({transId, type, selectionActiveClass, collapseActiveSelection, className}) => {
    if(type === 'pages') {
        return (
            <WrapperAccordion
                selectionActiveClass={selectionActiveClass}
                transId={transId}
                className={className + ' single-section'}
                collapseActiveSelection={collapseActiveSelection}
            >
                <div className="selections-item-selections section-left">
                    <WebsiteMenuContainer 
                        type={type}
                    />
                </div>
            </WrapperAccordion>
        )
    } else {
        return (
            <WrapperAccordion
                selectionActiveClass={selectionActiveClass}
                transId={transId}
                className={className + ' single-section'}
                collapseActiveSelection={collapseActiveSelection}
            >
                <div className="selections-item-selections section-left">
                    <PagesListContainer
                        type={type}
                    />
                </div>
            </WrapperAccordion>
        )
    }
}

export default PagesSection